import { FaRegBell } from "react-icons/fa";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import whiteLogo from '../assets/footer-logo.png'
import dummyUserImage from "../assets/dummy/dummy-user.png";
import settingsIcon from "../assets/icons/settings-icon.svg";
import campaignsIcon from "../assets/icons/white-hamburger.svg";
import dashboardIcon from "../assets/icons/dashboard-icon.svg";
import logoutIcon from "../assets/icons/log-out.svg";
import { useEffect, useRef, useState } from "react";
import hamburger from "../assets/icons/black-hamburger.svg";
import {
  closeSidebar_admin,
  toggleSidebar_admin,
} from "../store/shared/actions";
import { useDispatch, useSelector } from "react-redux";
import { IAppState } from "../store/store";
import { CgArrangeBack } from "react-icons/cg";
import { CiShop } from "react-icons/ci";
import { BiSort } from "react-icons/bi";
import { FiSearch } from "react-icons/fi";

export const AdminLayout = () => {
  const navOpen = useSelector((state: IAppState) => state.shared.navOpenAdmin);
  const sidebarRef = useRef<HTMLDivElement>(null);
  const dispatch = useDispatch();
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    document.addEventListener("click", closeSideBar_, true);
    return () => {
      document.removeEventListener("click", closeSideBar_, true);
    };
  }, []);

  const closeSideBar_ = (e: MouseEvent) => {
    if (
      sidebarRef.current?.contains(e.target as Node) ||
      (e.target instanceof Element &&
        e.target.classList.contains("exempt_sidebar_close"))
    ) {
      // The click occurred within the sidebar or on an exempt element, so do nothing.
      return;
    }
    //   close sidebar
    dispatch(closeSidebar_admin());
  };

   const handleSubmitSearch = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    // closeNav();
    setSearchQuery("");
    // console.log();
    navigate(`/admin/product-search/${searchQuery}`);
  };

  return (
    <>
      {/* nav area */}
      <div
        ref={sidebarRef}
        className={`fixed bg-[#0e203f] shadow w-[250px] z-50 flex flex-col justify-between h-screen overflow-y-auto duration-700 ${
          navOpen ? "translate-x-0" : "translate-x-[-1000px]"
        } lg:!translate-x-0`}
      >
        <div className="p-6 pl-10">
          <img src={whiteLogo} className="w-[140px]" alt="Logo" />
        </div>
        <nav className="mt-8 font-montserrat text-white">
          <NavLink
            onClick={() => dispatch(closeSidebar_admin())}
            end
            to="/admin"
            className="flex items-center gap-3 py-2 pl-10 2xl:px-12 pr-6 admin_nav"
          >
            <img src={dashboardIcon} className="w-6" />
            <span className="text-lg">Dashboard</span>
          </NavLink>
          <NavLink
            onClick={() => dispatch(closeSidebar_admin())}
            to="/admin/campaigns"
            className="flex items-center gap-3 py-2 pl-10 2xl:px-12 pr-6 admin_nav"
          >
            <img src={campaignsIcon} className="w-6" />
            <span className="text-lg">Campaigns</span>
          </NavLink>
          <NavLink
            onClick={() => dispatch(closeSidebar_admin())}
            to="/admin/order-campaigns"
            className="flex  items-center gap-3 py-2 pl-10 2xl:px-12 pr-6 admin_nav"
          >
            <CgArrangeBack size={30} className="text-white" />
            <span className="text-lg">Order Campaigns</span>
          </NavLink>
          <NavLink
            onClick={() => dispatch(closeSidebar_admin())}
            to="/admin/products"
            className="flex  items-center gap-3 py-2 pl-10 2xl:px-12 pr-6 admin_nav"
          >
            <CiShop size={30} className="text-white" />
            <span className="text-lg">Products</span>
          </NavLink>
          <NavLink
            onClick={() => dispatch(closeSidebar_admin())}
            to="/admin/sort-products"
            className="flex  items-center gap-3 py-2 pl-10 2xl:px-12 pr-6 admin_nav"
          >
            <BiSort size={30} className="text-white" />
            <span className="text-lg">Sort Products</span>
          </NavLink>
          <NavLink
            onClick={() => dispatch(closeSidebar_admin())}
            to="/admin/settings"
            className="flex items-center gap-3 py-2 pl-10 2xl:px-12 pr-6 admin_nav"
          >
            <img src={settingsIcon} className="w-6" />
            <span className="text-lg">Settings</span>
          </NavLink>
        </nav>
        <div className="flex-grow"></div>
        <div className="font-montserrat text-white">
          <NavLink
            to="/"
            className="mt-auto mb-8 flex items-center gap-3 py-2 pl-10 2xl:px-12 pr-6 admin_nav"
          >
            <img src={logoutIcon} className="w-6" />
            <span className="text-lg">Logout</span>
          </NavLink>
        </div>
      </div>

      <div className="lg:w-[calc(100vw-250px)] lg:ml-auto">
        <nav className="bg-white py-4 sticky top-0 z-10 flex items-center justify-between">
            <form onSubmit={handleSubmitSearch} className="w-2/5">
                        <div className="relative flex items-center   justify-between xl:ml-10 border-2 border-black border-solid rounded-[21px] pl-10 pr-4 h-[41px]">
                          <FiSearch className="absolute center_y left-4 text-2xl" />
                          <input
                            type="input"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            className="outline-none ml-3 w-full"
                          />
                          {/* <Link to={`/campaign-search/${searchQuery}`}>Search</Link> */}
                          <button type="submit">Search</button>
                        </div>
                      </form>
          <div className="px-4 sm:px-6 lg:px-8 2xl:px-14 flex gap-5 justify-end items-center">
            <div className="flex-1 lg:hidden">
              <img
                onClick={() => dispatch(toggleSidebar_admin())}
                src={hamburger}
                alt="hamburger-icon"
                className="exempt_sidebar_close w-[18px] cursor-pointer"
              />
            </div>
            <div>
              <FaRegBell className="text-[#0E203F] text-2xl" />
            </div>
            <div>
              <img
                src={dummyUserImage}
                alt="User"
                className="rounded-full h-8 w-8 lg:w-14 lg:h-14"
              />
            </div>
          </div>
        </nav>

        {/* moved the min height here */}
        <div className="min-h-[calc(100vh-90px)] px-4 sm:px-6 lg:px-8 2xl:px-14 py-8 md:py-10 tall:py-[72px] 2xl:py-[72px] bg-[#F6F6F6]">
          <Outlet />
        </div>
      </div>
    </>
  );
};
